import { FC, useEffect } from 'react';
import Option from './Option';

interface iListSelectProps {
  options: {
    title: string;
    description?: string;
    value: string;
    price?:
      | number
      | ((size: string, value: any, config: any, priceResolver?: null | ((size: string) => number)) => number);
    style?: any;
    disabled?: string[];
  }[];
  value: string;
  onChange: (value: string) => void;
  preview?: any;
  config?: any;
  priceResolver?: null | ((size: string) => number);
  preventPreview?: boolean;
}

const ListSelect: FC<iListSelectProps> = ({
  options,
  value,
  onChange,
  preventPreview,
  preview,
  config,
  priceResolver,
}) => {
  const previewValue = preview
    ? preview?.reduce((sum: string, line: any) => sum + ' ' + line.children.map((_: any) => _.text).join(''), '')
    : null;
  const activeOption = options.find((_) => _.value === value);
  let currentPrice = 0;

  if (typeof activeOption?.price === 'number') currentPrice = activeOption.price;
  else if (typeof activeOption?.price === 'function') {
    currentPrice = activeOption.price(config?.size, preview, config, priceResolver);
  }

  useEffect(() => {
    if (activeOption?.disabled?.includes(config?.size)) {
      onChange(
        [...options].reverse().find((option) => !option.disabled?.includes(config?.size))?.value || options[0].value,
      );
    }
  }, [config?.size, value]);
  return (
    <div className='list-select-wrapper'>
      {options.map((option) => {
        let price = undefined;
        if (typeof option.price === 'number') price = option.price;
        else if (typeof option.price === 'function')
          price = option.price(config?.size || 'MEDIUM', preview, config, priceResolver);
        return (
          <Option
            preventPreview={preventPreview}
            preview={previewValue}
            {...option}
            disabled={option.disabled?.includes(config?.size)}
            key={option.value}
            active={value === option.value}
            onSelect={onChange}
            price={price !== undefined ? price - currentPrice : undefined}
          />
        );
      })}
    </div>
  );
};

export default ListSelect;
